import { useEffect } from 'react';

export default function useShadowCSS(shadowRoot: ShadowRoot) {
  useEffect(() => {
    if (import.meta.env.DEV) {
      const styles = Array.from(
        document.head.querySelectorAll('style[data-vite-dev-id], style[data-library], link[rel="stylesheet"]'),
      );

      styles.forEach((el) => {
        const clone = el.cloneNode(true);
        shadowRoot.appendChild(clone);
      });

      return () => {
        Array.from(
          shadowRoot.querySelectorAll('style[data-vite-dev-id], style[data-library], link[rel="stylesheet"]'),
        ).forEach((el) => el.remove());
      };
    }
  }, [shadowRoot]);
}
